var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-principal'),(_vm.accessDisplay)?_c('div',[(_vm.getHeader)?_c('div',{staticClass:"page-wrapper",on:{"click":_vm.ShowHiddenAside}},[_c('router-view')],1):_vm._e()]):_vm._e(),_c('footer-principal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }